const brezzaSliders = [
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/exterior_web_03.webp',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/exterior_web_03.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/exterior_web_01.webp',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/exterior_web_01.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/exterior_web_02.webp',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/exterior_web_02.webp',
  },

  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/exterior_web_04.webp',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/exterior_web_04.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/exterior_web_05.webp',

    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/exterior_web_05.webp',
  },
  {
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/highlight_web_01.webp',

    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/highlight_web_01.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/highlight_web_02.webp',

    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/highlight_web_02.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/highlight_web_04.webp',

    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/highlight_web_04.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/highlight_web_05.webp',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/highlight_web_05.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/highlight_web_06.webp',

    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/highlight_web_06.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/Interior_web_01.webp',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/Interior_web_01.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/Interior_web_02.webp',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/Interior_web_02.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/Interior_web_03.webp',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/Interior_web_03.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/Interior_web_04.webp',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/Interior_web_04.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/Interior_web_05.webp',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/Interior_web_05.webp',
  },
];

const brezzaColors = [
  {
    id: 1,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/colors/brave_khaki.webp',
  },
  {
    id: 2,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/colors/exuberant_blue.webp',
  },
  {
    id: 3,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/colors/magna_grey.webp',
  },
  {
    id: 4,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/colors/pearl+_arctic_white_roof.webp',
  },
  {
    id: 5,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/colors/pearl_arctic_white.webp',
  },
  {
    id: 6,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/colors/sizzling_red_black_roof.webp',
  },
  {
    id: 7,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/colors/sizzling_red.webp',
  },
  {
    id: 8,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/colors/splendid_silver_black_roof.webp',
  },
  {
    id: 9,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/colors/splendid_silver.webp',
  },
  {
    id: 10,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/brezza/brezza-black.webp',
  },
];

const brezzaVariants = [
  {
    id: 1,
    title: 'LXI',
    transmission: 'manual',
    mileage: '17.03',
    price: '₹ 8,69,000 Lakh',
  },
  {
    id: 2,
    title: 'VXi',
    transmission: 'manual',
    mileage: '17.03',
    price: '₹ 9,75,000 Lakh',
  },
  {
    id: 3,
    title: ' VXI AT',
    transmission: 'automatic',
    mileage: '17.03',
    price: '₹ 11,15,000 Lakh',
  },
  {
    id: 4,
    title: 'zXi',
    transmission: 'manual',
    mileage: '18.76',
    price: '₹ 11,14,500 Lakh',
  },
  {
    id: 5,
    title: 'ZXi (D)',
    transmission: 'manual',
    mileage: '17.03',
    price: '₹ 12,82,000 Lakh',
  },

  {
    id: 6,
    title: 'ZXi at',
    transmission: 'automatic',
    mileage: '17.03',
    price: '₹ 12,54,500 Lakh',
  },
  {
    id: 7,
    title: 'ZXi at (D)',
    transmission: 'automatic',
    mileage: '17.03',
    price: '₹ 12,70,500 Lakh',
  },
  {
    id: 8,
    title: 'ZXi+',
    transmission: 'manual',
    mileage: '17.03',
    price: '₹ 12,58,500 Lakh',
  },
  {
    id: 9,
    title: 'ZXi+ (D)',
    transmission: 'manual',
    mileage: '18.76',
    price: '₹ 12,74,000 Lakh',
  },
  {
    id: 10,
    title: 'ZXi+ at',
    transmission: 'automatic',
    mileage: '17.03',
    price: '₹ 13,98,000 Lakh',
  },
  {
    id: 11,
    title: ' ZXi+ at (D)',
    transmission: 'automatic',
    mileage: '18.76',
    price: '₹ 14,14,000 Lakh',
  },
  {
    id: 12,
    title: 'lxi (o) cng',
    transmission: 'MANUAL	',
    mileage: '18.76',
    price: '₹ 9,29,000 Lakh',
  },
  {
    id: 13,
    title: 'vxi (o) cng ',
    transmission: 'MANUAL	',
    mileage: '18.76',
    price: '₹ 10,64,500 Lakh',
  },
  {
    id: 14,
    title: 'zxi (o) cng (D)',
    transmission: 'MANUAL	',
    mileage: '18.76',
    price: '₹ 12,25,500 Lakh',
  },
  {
    id: 15,
    title: 'zxi (o) cng ',
    transmission: 'MANUAL	',
    mileage: '18.76',
    price: '₹ 12,09,500 Lakh',
  },
  {
    id: 16,
    title: '',
    transmission: '',
    mileage: '',
    price: '',
  },
];

const brezzaMileage = [
  {
    id: 1,
    title: 'Petrol (LXI and VXI)',
    transmission: 'manual',
    mileage: '17.38 KM/L',
  },
  {
    id: 2,
    title: 'Petrol (ZXI and ZXI+)',
    transmission: 'manual',
    mileage: '17.38 KM/L',
  },
  {
    id: 3,
    title: 'petrol',
    transmission: 'automatic',
    mileage: '19.80 KM/L',
  },
  {
    id: 4,
   title: 'cng',
    transmission: 'manual',
    mileage: '25.51 KM/KG',
  },
];

 const brezzaData = {
  name: "Brezza",
  brand: "Maruti Suzuki",
  priceRange: "₹ 8.34 - 14.14 Lakh*",
  specs: [
    { label: "Engine", value: "1462 cc", icon: "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/local/speedometer.png", },
    { label: "Mileage", value: "25.51 km/kg*",icon: "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/local/gas-station.png", },
    { label: "Power (PS)", value: "87.8",icon : "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/local/car.png", },
  ],
  iconUrls: [
    "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/icons/AGS.webp",
    "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/icons/S-CNG_mimimum+black.webp",
    "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/icons/K-SERIES.webp",
  ],
  brochureLink:
    "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/brochures/Brezza2022_Hot_Techy_SUV_Broucher.pdf",
  compareLink: "/compare-cars",
  cngLink: "/maruti-brezza-cng-on-road-price",
};


export { brezzaSliders, brezzaColors, brezzaVariants, brezzaMileage,brezzaData };
